const getCognitoUser = state => state.auth.user;

export default getCognitoUser;